import { get } from "lodash";

import { FilterFieldOptionsHookResult } from "~/features/filter";
import { onScrollBottomDealers } from "~/hooks/selectDealerValue";
import { DealerStatus } from "~/schemas/generated/graphql";

/** Дилеры для мультиселекта фильтра: пагинация скроллом + серверный поиск. */
export const useDealersOptions = (): FilterFieldOptionsHookResult => {
  const dealersInstance = onScrollBottomDealers(DealerStatus.Active);

  return {
    options: get(dealersInstance, "dealersForSelect", []).map(
      ({ value, label }) => ({ value: String(value), label }),
    ),
    loading: dealersInstance.GetViolationTypesLoading,
    onScrollBottom: dealersInstance.introspectionHandler,
    searchOptions: dealersInstance.searchDealer,
  };
};
